export const POP_UPS = {
    SERVICE_CHARGE: "SERVICE_CHARGE",
    PENDING_CHALLAN: "PENDING_CHALLAN",
    PAYMENT_TIMELINE: "PAYMENT_TIMELINE",
    OFFERS: "OFFERS",
    SPP_CHARGES: "SPP_CHARGES"
};

export const BREAKUP_CHARGES = {
    CHALLAN_CHARGES: "Challan Charges",
    SERVICE_CAHRGES: "Service Charges",
    SPP_CHARGES: "SPP Charges"
};
